import React, { useState, useEffect,useMemo } from 'react';
import Web3 from 'web3';
import { getStandardGas } from '../utils/getStandardGas';
import './GasDisplay.css';

const GasDisplay = () => {
  const [gasPrice, setGasPrice] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  
  
  // Check if gas is high (above 0.1 Gwei)
  const isGasHigh = gasPrice && Number(gasPrice) > 100000000; // 0.1 Gwei in wei
  const web3 = useMemo(() => new Web3('https://bsc-dataseed.bnbchain.org'), []);

  useEffect(() => {
    let isMounted = true;
    let intervalId;
    
    const fetchGasPrice = async () => {
      setIsLoading(true);
      try {
        // Use the web3 instance from useWeb3React if available

        
        const standardGas = await getStandardGas(web3);
        if (isMounted) {
          setGasPrice(standardGas);
          setError(null);
        }
      } catch (err) {
        if (isMounted) {
          setError('获取Gas价格失败');
          console.error('Error fetching gas price:', err);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };
    
    // Fetch gas price initially
    fetchGasPrice();
    
    // Set up interval to refresh gas price every 30 seconds
    intervalId = setInterval(fetchGasPrice, 30000);
    
    // Clean up
    return () => {
      isMounted = false;
      clearInterval(intervalId);
    };
  }, []);
  
  // Format gas price to Gwei
  const formattedGasPrice = gasPrice ? (Number(gasPrice) / 1e9).toFixed(2) : '0.00';
  if(!isGasHigh){
    return null;
  }
  return (
    <div className="gas-display">
      {isGasHigh && !isLoading && !error && (
        <div className="gas-warning">
          ⚠️ 当前链上繁忙，不建议刷分，会有较高的手续费
        </div>
      )}
    </div>
  );
};

export default GasDisplay; 